import React from 'react';
import axios, { type AxiosResponse } from 'axios';
import { tokenType } from './tokenManagementService/constant';
import { baseApiUrl } from 'src/config';
import { getAccessToken, logoutUser } from 'src/routes/AuthContext';
import { getClientIpHeader } from './clientIpService/getClientIp';

const useAxiosInterceptor = () => {
  const axiosInstance = axios.create({
    baseURL: baseApiUrl,
  });

  axiosInstance.interceptors.request.use(
    async (request: any) => {
      //  In parallel: the IP is cached for 10 minutes, but a cold lookup shouldn't queue behind a
      //  token refresh.
      const [__ttData, clientIpHeader] = await Promise.all([getAccessToken(), getClientIpHeader()]);
      const facilityId = localStorage.getItem('facilityId');
      request.headers.Authorization = `${tokenType} ${__ttData}`;
      Object.assign(request.headers, clientIpHeader);
      request.headers['Facility_id'] = facilityId || '';
      if (window.location.hostname === 'localhost') {
        request.headers['X-TENANT-ID'] = localStorage.getItem('realm') || '';
      } else {
        request.headers['X-TENANT-ID'] = window.location.hostname.split('-')[0];
      }
      return request;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    (error: any) => {
      if (error.response?.status === 401) {
        logoutUser();
        return Promise.reject(error);
      }
      return error.response;
    }
  );

  return axiosInstance;
};

export default useAxiosInterceptor;
